interface RuntimeEnv {
  apiUrl: string;
}

function required(name: string, value: string | undefined): string {
  if (value === undefined || value === '') {
    throw new Error(`Variável de ambiente ${name} não definida.`);
  }
  return value;
}

export const env: RuntimeEnv = {
  apiUrl: required('VITE_API_URL', import.meta.env.VITE_API_URL),
};
